import { createTickerMessageComponent } from '@modules/src/ticker/createTickerMessageComponent'
import { Orientation } from '@modules/src/enums/Orientation'
import GameSignals from '@/signals/GameSignals'
import { TickerMessageManager } from '@/managers/ui/TickerMessageManager'
import {
    createTickerMessageEvents,
    resolveTickerIdleMessage,
    TICKER_TEXT_NAME,
    TICKER_PARKED_SPIN_START_SIGNAL,
    TICKER_PARKED_TOTAL_WIN_SIGNAL,
    tickerMessagePosition,
    tickerMessageTextPosition,
} from '@/managers/ui/TickerMessageSignalsManager'
import { createTickerVisualHandlers } from '@/managers/ui/TickerMessageVisualController'
import { TICKER_MESSAGE_STYLE } from '@/containers/common/TextStyles'

const TICKER_BG_NAME = 'TickerMessageBg'
const TICKER_ELECTRO_NAME = 'TickerMessageElectro'
const tickerVisualHandlers = createTickerVisualHandlers(resolveTickerIdleMessage, {
    backgroundTexture: 'ticker.png',
    backgroundName: TICKER_BG_NAME,
    electroTexture: 'electro.png',
    electroName: TICKER_ELECTRO_NAME,
})

export const TICKER_MESSAGE_COMPONENT = createTickerMessageComponent({
    name: 'TickerMessageContainer',
    textName: TICKER_TEXT_NAME,
    zIndex: new Map<Orientation, number>([
        [Orientation.LANDSCAPE, 410],
        [Orientation.PORTRAIT, 410],
    ]),
    signals: {
        completeSplashScreenState: GameSignals.completeSplashScreenState,
        idle: GameSignals.idle,
        startSpin: TICKER_PARKED_SPIN_START_SIGNAL as any,
        showRegularWin: TICKER_PARKED_TOTAL_WIN_SIGNAL as any,
    },
    resolveIdleMessage: resolveTickerIdleMessage,
    spinStartMessage: 'Good Luck!',
    position: tickerMessagePosition,
    textPosition: tickerMessageTextPosition,
    textStyle: [
        {
            orientation: Orientation.ANY,
            options: TICKER_MESSAGE_STYLE,
        },
    ],
    formatWinAmount: TickerMessageManager.formatWinAmount,
    overrides: {
        container: {
            // Framework defaults to visible; keep hidden until splash/intro is done.
            visible: false,
            events: createTickerMessageEvents(tickerVisualHandlers),
        },
    },
})
